// 意见反馈弹窗类型
enum FeedbackTypeEnum {
  Feedback = 1,
  Product = 4,
}

export default FeedbackTypeEnum;